//{{-- ------------------------------------------------------------ --}}
//{{-- Scripts for the Navbar blade                                 --}}
//{{-- ------------------------------------------------------------ --}}
$(function(){
    $('#logout_lnk').safeOn('click', function(evt) {
      evt.preventDefault();
      sc_triggerLocalStorageEvent('logout_reason', 'userlogout');
    });
});

//{{-- Ajax call to refresh the navbar - this is called from login.blade --}}
window.refreshNavbar = function() {
    $.get(nav_url_navbar, function(data) {
        var bar = data.substring(data.indexOf('<!--navbar begin -->'), data.indexOf('<!--navbar end -->')+18);
        $('.navbar').html(bar);
    });
}